import { render, staticRenderFns } from "./AcceptRequestModal.vue?vue&type=template&id=1ba83c08&"
import script from "./AcceptRequestModal.vue?vue&type=script&lang=js&"
export * from "./AcceptRequestModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports